import { Paper, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useIsDesktop } from 'Hooks/useIsDesktop';
import { OrderListDesktop } from './OrderListDesktop';
import { OrderListMobile } from './OrderListMobile';
import { EquipmentContext } from 'Context';
import { useContext } from 'react';
import { Header } from '../Header';

export const maxOrdersCount = 5;

export const EquipmentRecentOrders = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);
  const { recentOrders } = useContext(EquipmentContext);

  return (
    <>
      <Header />
      <Typography component='h2' variant='h5' mt={4} sx={{ mt: 4, mb: 3 }}>
        {dictionary.RecentOrders.title}
      </Typography>
      <Paper elevation={0} sx={{ bgcolor: 'transparent' }}>
        <Stack>
          {isDesktop ? (
            <OrderListDesktop recentOrders={recentOrders} />
          ) : (
            <OrderListMobile recentOrders={recentOrders} />
          )}
        </Stack>
      </Paper>
    </>
  );
};
